import {useGlobalLoaderStore} from './global-loader-store';

// Overlay del loader global. Se monta una sola vez en el provider raíz.
export function GlobalLoaderOverlay() {
  const visible = useGlobalLoaderStore(s => s.visible);
  const message = useGlobalLoaderStore(s => s.message);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[100000] flex flex-col items-center justify-center bg-background/80 backdrop-blur-md">
      <div className="mb-16 h-48 w-48 animate-spin rounded-full border-4 border-indigo-500 border-t-transparent" />
      <span className="text-15 font-bold text-main">{message || 'Procesando...'}</span>
    </div>
  );
}
